import { render } from "./CommonMessagesTable.vue?vue&type=template&id=143ee6dc"
import script from "./CommonMessagesTable.vue?vue&type=script&lang=ts"
export * from "./CommonMessagesTable.vue?vue&type=script&lang=ts"
script.render = render

export default script